// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#blocklyContainer {
  height: 90% !important;
  width: 100% !important;
}

.block-form {
  padding: 10px 20px;
}

.mat-mdc-dialog-container {
  padding: 0px 10px 0px 10px !important;
}

.blocklyText,
.blocklyHtmlInput,
.blocklyTreeLabel {
  font-family: "Lato" !important;
}

.blocklyTreeLabel {
  font-size: 12px !important;
}

.blocklyTreeRow {
  height: 28px !important;
  margin-top: 5px !important;
}

.divider {
  margin-top: 50px;
}

.control-icon {
  font-size: 14pt;
}

.btn-form {
  color: var(--primary);
  background: #ffffff;
  border-radius: 4px;
  cursor: pointer;
  z-index: 5;
  margin-left: 10px;
  min-height: 36px;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 500;
}

.block-auto-description {
  background: none;
  max-height: 100px;
  width: 32%;
  overflow: scroll;
  position: absolute;
  right: 12%;
  top: calc(6% + 80px);
  z-index: 999999 !important;
  border-radius: 4px;
  border-width: 1px;
  border-color: var(--primary);
  border-style: solid;
  padding: 4px;
  margin: 0px 0px 10px 0px;
  color: var(--primary);
  opacity: 80%;
  box-shadow: 1px 1px 4px grey;
}
.block-auto-description .block-error {
  display: block !important;
  width: 100%;
  padding-left: 8px;
}
.block-auto-description .block-error mat-icon {
  vertical-align: bottom;
}`, "",{"version":3,"sources":["webpack://./src/app/auto-cx/components/auto-cx-blockly/auto-cx-blockly.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAIA;EACE,qCAAA;AADF;;AAIA;;;EAGE,8BAAA;AADF;;AAIA;EACE,0BAAA;AADF;;AAIA;EACE,uBAAA;EACA,0BAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,4BAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,qBAAA;EACA,YAAA;EACA,4BAAA;AADF;AAGE;EACE,yBAAA;EACA,WAAA;EACA,iBAAA;AADJ;AAGI;EACE,sBAAA;AADN","sourcesContent":["#blocklyContainer {\n  height: 90% !important;\n  width: 100% !important;\n}\n\n.block-form {\n  padding: 10px 20px;\n}\n\n.select-icon-field {}\n\n.mat-mdc-dialog-container {\n  padding: 0px 10px 0px 10px !important;\n}\n\n.blocklyText,\n.blocklyHtmlInput,\n.blocklyTreeLabel {\n  font-family: 'Lato' !important;\n}\n\n.blocklyTreeLabel {\n  font-size: 12px !important;\n}\n\n.blocklyTreeRow {\n  height: 28px !important;\n  margin-top: 5px !important;\n}\n\n.divider {\n  margin-top: 50px;\n}\n\n.control-icon {\n  font-size: 14pt;\n}\n\n.btn-form {\n  color: var(--primary);\n  background: #ffffff;\n  border-radius: 4px;\n  cursor: pointer;\n  z-index: 5;\n  margin-left: 10px;\n  min-height: 36px;\n  padding: 0 16px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.block-auto-description {\n  background: none;\n  max-height: 100px;\n  width: 32%;\n  overflow: scroll;\n  position: absolute;\n  right: 12%;\n  top: calc(6% + 80px);\n  z-index: 999999 !important;\n  border-radius: 4px;\n  border-width: 1px;\n  border-color: var(--primary);\n  border-style: solid;\n  padding: 4px;\n  margin: 0px 0px 10px 0px;\n  color: var(--primary);\n  opacity: 80%;\n  box-shadow: 1px 1px 4px grey;\n\n  .block-error {\n    display: block !important;\n    width: 100%;\n    padding-left: 8px;\n\n    mat-icon {\n      vertical-align: bottom;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
